module.exports = __webpack_public_path__ + "static/media/inmar.d8bc4e3f.png";